const KEY = "kingly-barn-mode";

export const isBarnMode = () =>
  document.documentElement.classList.contains("barn-mode");

export const initBarnMode = () => {
  try {
    if (localStorage.getItem(KEY) === "1") {
      document.documentElement.classList.add("barn-mode");
    }
  } catch { /* storage unavailable */ }
};

export const setBarnModePref = (on) => {
  document.documentElement.classList.toggle("barn-mode", on);
  try { localStorage.setItem(KEY, on ? "1" : "0"); } catch { /* ignore */ }
  window.dispatchEvent(new Event("barn-mode-change"));
};
